import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService, Currency, CurrencyService, TIMEZONES } from '@rubii/frontend-common';
import { ConfigService } from '../../../services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-criteo',
  templateUrl: './criteo.component.html',
  styleUrls: ['./criteo.component.scss']
})
export class CriteoComponent extends BaseDatasourceComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private client: ClientService, private currencySvc: CurrencyService,
    private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  currencies: Currency[] = [];

  timezones: string[] = [];

  async ngOnInit() {
    this.connectionForm = new FormGroup({
      currency: new FormControl('AUD', [Validators.required]),
      timezone: new FormControl('Australia/Sydney', [Validators.required]),
    });

    this.currencies = await this.currencySvc.getCurrencies();
    this.timezones = TIMEZONES;
  }

  save() {
    this.data.saveFunction(this.connectionForm.value.currency, this.connectionForm.value.timezone, () => {
      this.dialogRef.close();
    });
  }

}
